const MONTH_NAMES = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];

export const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = MONTH_NAMES[date.getMonth()];
    const year = date.getFullYear();
    return `${day} ${month} ${year}`;
};

export const formatQuantity = (qty) => {
    const num = parseFloat(qty);
    if (Number.isNaN(num)) return '0';
    const fixed = num.toFixed(3);
    return fixed.endsWith('.000') ? String(Math.round(num)) : fixed;
};

export const formatCurrency = (amount) => {
    if (amount === undefined || amount === null || amount === '') return '0.000';
    return parseFloat(amount).toFixed(3);
};

export const getText = (value, preferredLang = 'en') => {
    if (!value) return '';
    if (typeof value === 'string') return value;
    if (typeof value === 'object') {
        if (value[preferredLang]) return value[preferredLang];
        const first = Object.values(value)[0];
        return typeof first === 'string' ? first : '';
    }
    return String(value);
};

/** Unwrap Laravel resource `{ data: {...} }` envelopes from Redux/API payloads. */
export const unwrapResourceData = (payload) => {
    if (!payload || typeof payload !== 'object') return payload;
    if (payload.data && typeof payload.data === 'object' && !Array.isArray(payload.data)) {
        return payload.data;
    }
    return payload;
};

export const resolveDocumentId = (payload, routeId) => {
    const data = unwrapResourceData(payload);
    return data?.id || routeId || null;
};
